import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { map, catchError } from 'rxjs/operators';

import { Ciudad } from '../models/ciudad';
import { environment } from '../../../environments/environment';

@Injectable()
export class CiudadService {

  private urlEndPoint: string = environment.ciudadEndPoint;

  constructor(private http: HttpClient) { }

  ciudadesPorIdCompania(idCompania: number): Observable<Ciudad[]> {
    return this.http.get(this.urlEndPoint + 'porcompania/' + idCompania).pipe(
      map((response) => response as Ciudad[]),
    );
  }

  listarCiudades(): Observable<Ciudad[]> {
    return this.http.get(this.urlEndPoint + 'listar').pipe(
      map((response) => response as Ciudad[]),
    );
  }
    // Consume el servicio que activa una Vlan
    crearCiudad(parametros: Ciudad): Observable<Ciudad> {
      return this.http.post(this.urlEndPoint + 'crearCiudad',
        parametros, { responseType: 'json' }).pipe(
          map((resultado) => resultado as Ciudad)
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/ciudad.service.ts